import { render, staticRenderFns } from "./GifteeAppIcon.vue?vue&type=template&id=e8947d1e&scoped=true&"
import script from "./GifteeAppIcon.vue?vue&type=script&lang=js&"
export * from "./GifteeAppIcon.vue?vue&type=script&lang=js&"
import style0 from "./GifteeAppIcon.vue?vue&type=style&index=0&id=e8947d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8947d1e",
  null
  
)

export default component.exports